Vue.asyncComponent('ak-icon', {
    name:'ak-icon',
    props: {
        icon: {
            type: String,
            required: false,
        }
    }
}, 'layout/ak-icon.html');